import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

// Exported so SignInModal.tsx validates against the same patterns rather than
// keeping its own copy.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const CODE_RE = /^\d{6}$/;

export async function sendEmailOtp(email: string): Promise<{ ok: boolean }> {
  if (!email || typeof email !== 'string' || !EMAIL_RE.test(email)) {
    throw new Error('Invalid email address');
  }
  const callable = httpsCallable(functions, 'sendEmailOtp');
  const res = await callable({ email });
  const data = (res?.data || {}) as any;
  return { ok: !!data.ok };
}

export async function verifyEmailOtp(email: string, code: string): Promise<{ token: string }> {
  if (!email || typeof email !== 'string' || !EMAIL_RE.test(email)) {
    throw new Error('Invalid email address');
  }
  if (!code || typeof code !== 'string' || !CODE_RE.test(code)) {
    throw new Error('Invalid code');
  }
  const callable = httpsCallable(functions, 'verifyEmailOtp');
  const res = await callable({ email, code });
  const data = (res?.data || {}) as any;
  if (!data?.token) {
    throw new Error('Sign-in failed');
  }
  return { token: data.token as string };
}
